import { Container } from 'pixi.js';
import { getLocalizedValue } from '@softgames/localization';
import { RaceEventPlayerFrameLayout } from '../../../../../layouts/raceEvent/RaceEventPlayerFrameLayout';
import type { LeaderboardEntry } from '../../../../app/platform/Platform';
import { applyLayoutState } from '../../../../libs/layouts/populateLayouts/applyLayoutState';
import { insertAvatar } from '../../../../game/utils/insertAvatar';
import { playLayoutAnimation } from '../../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class RaceAvatarFrameView extends Container {
  private readonly layout = new RaceEventPlayerFrameLayout();

  constructor(entry: LeaderboardEntry) {
    super();

    const { root, avatar, levelText } = this.layout;

    root.props({ parent: this });

    if (entry.player.currentUser) {
      applyLayoutState(this.layout, 'currentPlayer');
    }

    if (entry.player.avatarUrl) {
      void insertAvatar(avatar, entry.player.avatarUrl);
    }

    levelText.text = entry.score;
  }

  public async changeLevel(level: number): Promise<void> {
    const { levelText } = this.layout;

    await levelText.tweenTo({ scaleXY: 0 }, 200, 'cubicIn', true).asyncOnComplete();
    levelText.text = getLocalizedValue(level);
    await levelText.tweenTo({ scaleXY: 1 }, 200, 'cubicOut', true).asyncOnComplete();
  }

  public async animateDance(): Promise<void> {
    if (this.destroyed) return;
    await playLayoutAnimation(this.layout, 'Frame_Dance');
  }
}
